import { createReducer, on } from '@ngrx/store';
import {
  STATE_FIND_SUCCESS,
  STATE_FAILURE,
  STATE_UPDATE_FORM,
  STATE_RESET_ERROR,
  STATE_RESET,
  STATE_RESET_FORM,
  STATE_FIND_ALL_SUCCESS,
  STATE_EDIT_MODE,
  STATE_CLEAR_STATE,
} from '../actions';
import { ResponseBadRequest } from '@core/interfaces';
import {
  Estado,
  EstadoForm,
} from '@core/models';
import { transformStateData, transformStateForm } from '@core/helpers';

export interface StateState {
  loading: boolean;
  editMode: boolean;
  state: Estado | null;
  stateList: Estado[] | null;
  stateForm: EstadoForm | null;
  error: ResponseBadRequest | null;
}

export const initialState: StateState = {
  loading: false,
  editMode: false,
  state: null,
  stateList: null,
  stateForm: null,
  error: null,
};

export const stateReducer = createReducer(
  initialState,
  on(STATE_EDIT_MODE, (state, { editMode }) => ({ ...state, editMode })),
  on(STATE_FIND_SUCCESS, (state, { stateData }) => ({ ...state, state: transformStateData(stateData) })),
  on(STATE_FIND_ALL_SUCCESS, (state, { stateList }) => ({ ...state, stateList })),
  on(STATE_FAILURE, (state, { error }) => ({ ...state, error })),
  on(STATE_UPDATE_FORM, (state, { stateForm }) => ({ ...state, stateForm: transformStateForm(stateForm) })),
  on(STATE_RESET, (state) => ({ ...state, state: initialState.state })),
  on(STATE_RESET_ERROR, (state) => ({ ...state, error: initialState.error })),
  on(STATE_RESET_FORM, (state) => ({ ...state, stateForm: initialState.stateForm, loading: initialState.loading })),
  on(STATE_CLEAR_STATE, () => initialState),
);